import FuseScrollbars from '@fuse/core/FuseScrollbars';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { memo, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { Button, IconButton, Link, Stack, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Navigation from '../../shared-components/Navigation';
import UserMenu from '../../shared-components/UserMenu';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
import LogoIjro from '../../shared-components/LogoIjro';
import { CiMail } from 'react-icons/ci';
import Badge from '@mui/material/Badge';
import { NavbarEmailButton } from './NavbarEmailButton';
import LanguageSwitcher from 'app/theme-layouts/shared-components/LanguageSwitcher';
import SelectYear from 'app/theme-layouts/shared-components/SelectYear';
import { LangSwitcher } from 'app/theme-layouts/shared-components/lang-switcher';

const Root = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  color: '#20293A',
  width: '100%',
  position: 'fixed !important',
}));
const StyledAddOffer = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 0 #0003, 0 0 #00000024, 0 0 #0000001f',
  backgroundColor: '#4f46e5',
  color: '#fff', // margin: '20px 24px 0',
  padding: '0 20px',
  '&:hover': {
    backgroundColor: '#393298',
  },
  '& span': {
    width: '24px',
    height: '24px',
    margin: '0  8px 0 0',
    color: '#fff',
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
}));

function NavbarLayout2(props) {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <Root
      className={clsx('h-64 min-h-64 max-h-64 shadow-custom z-20 relative ', props.className)}
      style={{ width: openMenu ? '99.582%' : '100%' }}
    >
      <div className="flex flex-auto justify-between items-center w-full h-full  p-0 lg:px-24 z-20">
        <Stack direction="row" justifyContent="flex-start" alignItems="center" gap="32px">
          <div className="flex shrink-0 items-center px-8">
            <LogoIjro />
          </div>
        </Stack>
        <FuseScrollbars className="flex h-full items-center">
          <Navigation className="w-full" layout="horizontal" />
        </FuseScrollbars>
        <Stack direction="row" justifyContent="flex-end" alignItems="center" gap="8px">
          <NavbarEmailButton />
          <SelectYear />
          {/*<LanguageSwitcher />*/}
          {/*<LangSwitcher />*/}
          <StyledAddOffer onClick={() => navigate('/lawyer/add')}>
            <span>
              <AiOutlinePlus />
            </span>
            Янги ҳужжат
          </StyledAddOffer>
          <FullScreenToggle />
          <UserMenu openMenu={openMenu} setOpenMenu={setOpenMenu} />
        </Stack>
      </div>
    </Root>
  );
}

export default memo(NavbarLayout2);
